import { PHOTO_LOADER } from "../constants"

export default class LoaderElement {
  /**
   * @static
   * @param {HTMLElement} htmlElement
   * @returns
   * @memberof LoaderElement
   */
  static fromHtmlElement(htmlElement) {
    return new LoaderElement(htmlElement.querySelector(PHOTO_LOADER))
  }

  /**
   * Creates an instance of LoaderElement.
   * @param {HTMLElement} element
   * @memberof LoaderElement
   */
  constructor(element) {
    this.element = element
  }

  /**
   * @param {Boolean} shouldBeHidden
   * @memberof LoaderElement
   */
  toggleVisibility(shouldBeHidden) {
    this.element.classList.toggle("is-hidden", !shouldBeHidden)
  }
}
